import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from '@services';
import { getErrorMessage } from '@utils';
import { firstValueFrom } from 'rxjs';
import { IntegracaoPagamentoService } from '../../../services/integracao-pagamento.service';
import { fadeInOutTranslate } from '../../../shared/elements/animation';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';

@Component({
  selector: 'app-modal-pedidos-stone',
  templateUrl: './modal-pedidos-stone.component.html',
  styleUrls: ['./modal-pedidos-stone.component.css'],
  animations: [fadeInOutTranslate]
})
export class ModalPedidosStoneComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modal', { static: true }) modal;
  listagem = null;
  currentPage = 1;
  rowsOnPage = 10;

  colunas = [
    { label: 'Identificador', col: 'id' },
    { label: 'Descrição', col: 'poi_payment_settings.display_name' },
    { label: 'Valor', col: 'amount', format: v => v / 100, currency: true }, // recebemos em centavos
    { label: 'Status', col: 'status', format: this.getDescricaoStatus.bind(this) },
    { label: 'Fechado', col: 'closed', format: v => v ? 'Sim' : 'Não' },
  ];

  constructor(
    private messageService: MessageService,
    private integracaoPagamentoService: IntegracaoPagamentoService,
  ) {
    super();
  }

  ngOnInit() {
    this.listarPedidosStone();
  }

  async listarPedidosStone() {
    try {
      this.loading['listagem'] = true;
      this.listagem = await firstValueFrom(this.integracaoPagamentoService.listarPedidosStone(this.currentPage));
    } catch (err) {
      this.messageService.error(getErrorMessage(err), 8000);
    } finally {
      this.loading['listagem'] = false;
    }
  }

  show() {
    this.modal.show();
  }

  fechar() {
    this.closed.emit();
  }

  async cancelarPedido(pedido) {
    try {
      this.loading['acoes'] = true;
      await firstValueFrom(this.integracaoPagamentoService.cancelarPedido(pedido.id));
      await this.sleep(3000); // Para dar tempo de atualizar
      this.messageService.success('Pedido cancelado!', 5000);
      await this.listarPedidosStone();
    } catch (err) {
      this.messageService.error(getErrorMessage(err), 8000);
    } finally {
      this.loading['acoes'] = false;
    }
  }

  sleep(ms) {
    return new Promise((res, _) => { setTimeout(res, ms); });
  }

  async fecharPedido(pedido) {
    try {
      this.loading['acoes'] = true;
      await firstValueFrom(this.integracaoPagamentoService.fecharPedido(pedido.id));
      await this.sleep(3000); // Para dar tempo de atualizar
      this.messageService.success('Pedido fechado!', 5000);
      await this.listarPedidosStone();
    } catch (err) {
      this.messageService.error(getErrorMessage(err), 8000);
    } finally {
      this.loading['acoes'] = false;
    }
  }

  getDescricaoStatus(status) {
    switch (status) {
      case 'paid':
        return 'Pago';
      case 'canceled':
        return 'Cancelado';
      case 'pending':
        return 'Pendente';
      case 'failed':
        return 'Falha';
      default:
          return status;
    }
  }

  changePage(ev) {
    this.currentPage = ev.index;
    this.listarPedidosStone();
  }
}
